<router-outlet></router-outlet>
<app-footer></app-footer>
<!-- Custom Scroll Progress Button -->
<div class="scroll-progress-btn" [class.show]="scrollPercent > 2" (click)="scrollToTop()">
  <svg class="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
          pathLength="100"
          [style.stroke-dashoffset]="100 - scrollPercent"
          stroke-dasharray="100 100" />
  </svg>
  <div class="scroll-content">
    <i class="fa-solid fa-arrow-up"></i>
    <span class="scroll-percent">{{ scrollPercent }}%</span>
  </div>
</div>
